import { motion } from "framer-motion";
import { ShieldCheck, ExternalLink } from "lucide-react";

// Shows a user-clicked button to open Stripe Checkout in a NEW TAB.
// A direct anchor click is a genuine user gesture, so it works even inside
// the Emergent preview iframe (auto-redirects get blocked by the sandbox).
export const CheckoutOverlay = ({ url, onClose }) => {
  if (!url) return null;
  return (
    <div className="fixed inset-0 z-[200] bg-black/85 backdrop-blur-xl flex items-center justify-center p-6" data-testid="checkout-overlay">
      <motion.div initial={{ opacity: 0, y: 20, scale: 0.96 }} animate={{ opacity: 1, y: 0, scale: 1 }} className="glass rounded-3xl p-10 max-w-md w-full text-center">
        <div className="w-14 h-14 rounded-2xl bg-gold/15 flex items-center justify-center mx-auto mb-5">
          <ShieldCheck className="w-7 h-7 text-gold" />
        </div>
        <h2 className="font-display font-black text-2xl mb-2">Almost there!</h2>
        <p className="text-foreground/60 mb-8">Tap below to open the secure Stripe checkout in a new tab and complete your payment.</p>
        <a
          data-testid="continue-to-checkout"
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => setTimeout(onClose, 800)}
          className="flex items-center justify-center gap-2 w-full h-14 rounded-xl bg-gold hover:bg-gold/90 text-black font-semibold text-base transition-colors"
        >
          Continue to secure payment <ExternalLink className="w-4 h-4" />
        </a>
        <button data-testid="cancel-checkout" onClick={onClose} className="mt-4 text-sm text-foreground/50 hover:text-white transition-colors">
          Cancel
        </button>
      </motion.div>
    </div>
  );
};
